export const TypeAngles = {
    "41": 0,
    "42": 0,
    "56": 0,
    "57": 0,
}